export enum CategoryInputs {
	Code = "code",
	IsActive = "isActive",
	Name = "name",
	Description = "description",
	Category = "category",
}
